export class PriceOperation
{
    static millicent_to_cent(millicent: number): number
    {
        return Math.round(millicent / 1000);
    }
    static millicent_to_fiat(millicent: number, decimal: number = 2): number
    {
        let thousand = Math.max(5 - decimal, 0);
        let hundred = 5 - thousand;
        return Math.round(millicent / Math.pow(10, thousand)) / Math.pow(10, hundred);
    }
    static cent_to_millicent(cent: number): number
    {
        return Math.floor(cent * 1000);
    }
    static fiat_to_millicent(fiat: number): number
    {
        return Math.floor(fiat * 100 * 1000);
    }
}